<template>
  <v-card>
    <v-card-title v-if="!hideTittle">
      <slot name="title" v-bind:item="item">
           <span style="font-size:16px">
               <b>{{ getTittle() }}</b>
           </span>
      </slot>
    </v-card-title>
    <v-divider></v-divider>

    <v-list dens>
      <v-list-tile :key="key" v-for="(keyName,key) in keys">
        <v-list-tile-content>{{ getTranslation(keyName) }}:</v-list-tile-content>
        <v-list-tile-content class="align-end">{{ getValue(keyName) }}</v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>

    <v-card-actions v-if="!hideActions" class="justify-center">
      <slot name="actions" v-bind:item="item">
        <v-btn flat>Pokaż</v-btn>
      </slot>
    </v-card-actions>
  </v-card>
</template>
<script>
export default {
  props: ['item', 'translations', 'keys', 'titleKey', 'hideActions', 'hideTittle'],
  methods: {
    getTranslation(key) {
      return this.translations[key]
    },
    getTittle() {
      if (typeof (this.titleKey) == 'string') {
        return this.item[this.titleKey]
      }
      return this.titleKey.map(key => this.item[key]).join(" ")
    },
    getValue(keyName) {
      let val;
      keyName.split(".").forEach(el => val = val ? val[el] : this.item[el])
      return val
    }
  }
}
</script>
